/* eslint-disable react-hooks/exhaustive-deps */
import { BaseTable, Card, FooterMenu, Loading, Pagination } from "components"
import FilterByDate from "pages/Finance/Journal/components/FilterByDate"
import { useFilter } from "pages/Finance/Journal/utils/hooks"
import { Fragment, useEffect } from "react"
import { exportPdf, thisMonth, today } from "utils/functions"
import { DropdownAccount } from "../DropdownAccount"
import { ExportExcel, ExportPdf, Item } from "./components"
import { useRegisterReconcileList } from "./utils/hooks"
import { usePagination } from "../../utils/hooks"

export function RegisterReconciliation() {

  const {
    currentPage,
    limit,
    size,
    totalPage,
    total,
    onChangePage,
    onChangeLimit,
    onChangePaginationData
  } = usePagination()

  const todayDate = today()
  const thisMonthDate = thisMonth()

  const { filter, handleChangeFilter } = useFilter({
    CoaID: "0",
    dateFrom: thisMonthDate.fromDate,
    dateTo: todayDate
  })


  const { isLoading, data, pagination } = useRegisterReconcileList({
    params: {
      coa_id: filter.CoaID!,
      start_date: filter.dateFrom,
      end_date: filter.dateTo,
      page: currentPage,
      limit: limit
    }
  })

  useEffect(() => {
    if (pagination) {
      onChangePaginationData(pagination)
    }
  }, [pagination])

  return (
    <Fragment>
      <section className="mt-2">
        <Card>
          <Card.Body>
            <section className="container flex-col lg:flex lg:flex-row justify-center lg:justify-between">
              <div className="w-full lg:w-[36%] flex-col lg:flex lg:flex-row justify-center lg:justify-start items-center">
                <div className="label-text pb-1 font-bold pe-6 min-w-24">
                  Account CHQ
                </div>
                <DropdownAccount
                  value={null}
                  displayBalance={false}
                  onChange={(item) =>
                    handleChangeFilter({ CoaID: item?.value })
                  }
                />
              </div>
            </section>

            <section className="container flex-col lg:flex lg:flex-row justify-center lg:justify-between pt-1">
              <FilterByDate
                dateFrom={filter.dateFrom}
                dateTo={filter.dateTo}
                displayButtonShortcut={false}
                onChangeDateFrom={(date) =>
                  handleChangeFilter({ dateFrom: date })
                }
                onChangeDateTo={(date) =>
                  handleChangeFilter({ dateTo: date })
                }
                onClickPrevYear={() => null}
                onClickThisYear={() => null}
                onClickThisWeek={() => null}
                onClickThisMonth={() => null}
                onClickToday={() => null}
              />
            </section>
          </Card.Body>
        </Card>
      </section>

      <div className="overflow-x-scroll max-h-[calc(100vh-500px)] mt-2">
        <BaseTable className="border-transparent mb-2">
          <thead className="!bg-black !text-white">
            <tr className="uppercase">
              <th>No</th>
              <th>RCL ID#</th>
              <th>By</th>
              <th>
                New
                <br />
                Statement Date
              </th>
              <th>
                Last
                <br />
                Reconcile Date
              </th>
              <th>
                New
                <br />
                Statement Balance
              </th>
              <th>
                Last
                <br />
                Statement Balance
              </th>
              <th>
                Total
                <br />
                Cleared Debet
              </th>
              <th>
                Total
                <br />
                Cleared Credit
              </th>
              <th>
                Out of
                <br />
                Balance
              </th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {!data?.length || isLoading ? (
              <tr>
                <td colSpan={11} className="text-center">
                  <Loading
                    loading={isLoading}
                    errorText={isLoading ? "" : "No data available"}
                  />
                </td>
              </tr>
            ) : (
              data.map((item, key: number) => (
                <Item item={item} index={key} />
              ))
            )}
          </tbody>
        </BaseTable>


        {!isLoading && data.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPage={totalPage}
            size={size}
            limit={limit}
            total={total}
            onPageChange={onChangePage}
            onAddShow={(val) => onChangeLimit(Number(val))}
          />
        )}


        <section className="mb-2 mt-2">
          <FooterMenu
            export={{
              actiontype: "export",
              onClick: () => {
                ExportExcel({
                  data: data,
                  filter: {
                    dateFrom: filter.dateFrom,
                    dateTo: filter.dateTo
                  },
                  fileName: "finance_register_reconcilliation",
                  title: "FINANCE REGISTER RECONCILIATION"
                })
              }
            }}
            pdf={{
              actiontype: "pdf",
              onClick: () => {
                exportPdf({
                  documentComponent: (
                    <ExportPdf
                      data={data}
                      filter={{
                        dateFrom: filter.dateFrom,
                        dateTo: filter.dateTo
                      }}
                      title="FINANCE REGISTER RECONCILIATION"
                    />
                  ),
                  fileName: "finance_register_reconcilliation"
                })
              }
            }}
          />
        </section>
      </div>
    </Fragment>
  )
}
